import MyTeamsPageOverview from "../../Components/MyTeamPageComponents/MyTeamsPageOverview";

const MyTeamsPage = () => {
  return (
    <div>
      <MyTeamsPageOverview />
    </div>
  );
};

export default MyTeamsPage;
